<template>
  <div
    id="open-empty-wrapper"
    class="greedy flex column flex-align-center justify-center">
    <div
      class="open-empty flex column flex-align-center justify-center">
      <SBIcon
        :icon="SBIconList.NEW_MESSAGE"
        :color="SBColors.white"
        :background-color="SBColors.bluePrimary"
        :hover-size="50"
        :border-radius="50"
        :size="24"
        :pointer="true"
        @click="startNewConversation" />
      <h3>{{ showEmptyFresh ? 'Send your first message' : 'Send new message' }}</h3>
      <template v-if="showEmptyFresh">
        <p>Click the
          <SBIcon
            class="d-inline"
            :icon="SBIconList.NEW_MESSAGE"
            :color="SBColors.blackUltralight"
            :size="12" />
          icon to send a new message.</p>
      </template>
      <template v-else>
        <p>Click the
          <SBIcon
            class="d-inline"
            :icon="SBIconList.NEW_MESSAGE"
            :color="SBColors.blackUltralight"
            :size="12" />
          icon to send a new message.</p>
      </template>
      <b-button @click="startNewConversation">
        Send message
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';

export default {
  name: 'OpenEmpty',
  components: {
    SBIcon,
  },
  data() {
    return {
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      showEmptyFresh: 'chat/showEmptyFresh',
    }),
  },
  methods: {
    startNewConversation() {
      this.$eventBus.$emit('initiate-new-conversation');
    },
  },
};
</script>

<style lang="scss" scoped>
#open-empty-wrapper {
  overflow: hidden;
  margin: 0px;

  .open-empty {
    max-width: 480px;
    padding: 100px 77px;
    border-radius: 15px;
    border: solid 1px $linkHover;
    background-color: $greyUltralight;

    h3 {
      margin-top: 23px;
      font-size: 18px;
      font-weight: 500;
      color: $blackPrimary;
    }

    p {
      font-size: 15px;
      font-weight: 400;
      color: $blackUltralight;
      margin-top: 10px;
      line-height: 1.12;
      text-align: center;
      font-size: 15px;
      font-weight: 400;
    }

    .btn {
      margin-top: 31px;
    }
  }
}
</style>
